import React from 'react'
import Layout from '../Layout'
import DataTable from '../../../Components/DataTable'
import Button from '../../../Components/Button'
import ResourceIndexHeader from '../../../Components/ResourceIndexHeader'
import { useDeleteWithConfirmation } from '../../../hooks/useDeleteWithConfirmation'

export default function Index({ account, accounts, navigation, print_assets, params = {}, pagination }) {
  const handleDelete = useDeleteWithConfirmation('/manage/print_assets')

  const columns = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      render: (value, item) => (
        <div>
          <div className="font-medium text-gray-900">{value}</div>
          <div className="text-sm text-gray-500">
            {item.size_label} {item.orientation_label} &middot; {item.asset_filename || 'No file uploaded'}
          </div>
        </div>
      )
    },
    {
      key: 'qr_width',
      label: 'QR Placement',
      render: (value, item) => (
        <span className="text-gray-500">
          ({item.qr_x}mm, {item.qr_y}mm) &middot; {value}mm
        </span>
      )
    }
  ]

  return (
    <Layout account={account} accounts={accounts} navigation={navigation} title="Print Assets">
      <ResourceIndexHeader
        count={pagination ? pagination.count : print_assets.length}
        singular="print asset"
        plural="print assets"
        addHref="/manage/print_assets/new"
        addLabel="Add Print Asset"
      />

      <DataTable
        data={print_assets}
        columns={columns}
        actions={(item) => (
          <>
            <Button link href={`/manage/print_assets/${item.id}/edit`}>Edit</Button>
            <Button link variant="danger" onClick={() => handleDelete(item)}>Delete</Button>
          </>
        )}
        searchable={true}
        searchPlaceholder="Search print assets..."
        emptyState={{
          message: 'No print assets yet',
          action: { label: 'Create your first print asset', href: '/manage/print_assets/new' }
        }}
        baseUrl="/manage/print_assets"
        params={params}
        pagination={pagination}
      />
    </Layout>
  )
}
